var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.92C18.031 22.92 22.92 18.031 22.92 12C22.92 5.96905 18.031 1.08 12 1.08C5.96905 1.08 1.08 5.96905 1.08 12C1.08 18.031 5.96905 22.92 12 22.92ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#0C0C22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1602 6.24023H9.84023C7.85231 6.24023 6.24023 7.85231 6.24023 9.84023V14.1602C6.24023 16.1482 7.85231 17.7602 9.84023 17.7602H14.1602C16.1482 17.7602 17.7602 16.1482 17.7602 14.1602V9.84023C17.7602 7.85231 16.1482 6.24023 14.1602 6.24023ZM16.6802 14.1602C16.6802 15.5498 15.5498 16.6802 14.1602 16.6802H9.84023C8.45063 16.6802 7.32023 15.5498 7.32023 14.1602V9.84023C7.32023 8.45063 8.45063 7.32023 9.84023 7.32023H14.1602C15.5498 7.32023 16.6802 8.45063 16.6802 9.84023V14.1602Z",
    fill: "#0C0C22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 9.12023C10.4098 9.12023 9.12023 10.4098 9.12023 12.0002C9.12023 13.5907 10.4098 14.8802 12.0002 14.8802C13.5907 14.8802 14.8802 13.5907 14.8802 12.0002C14.8802 10.4098 13.5907 9.12023 12.0002 9.12023ZM12.0002 13.8002C11.0081 13.8002 10.2002 12.9924 10.2002 12.0002C10.2002 11.0074 11.0081 10.2002 12.0002 10.2002C12.9924 10.2002 13.8002 11.0074 13.8002 12.0002C13.8002 12.9924 12.9924 13.8002 12.0002 13.8002Z",
    fill: "#0C0C22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0962 9.28799C15.3082 9.28799 15.48 9.11618 15.48 8.90423C15.48 8.69229 15.3082 8.52047 15.0962 8.52047C14.8843 8.52047 14.7125 8.69229 14.7125 8.90423C14.7125 9.11618 14.8843 9.28799 15.0962 9.28799Z",
    fill: "#0C0C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.47940b6eff2fac8619f578cc62abaffb.svg";
export { ForwardRef as ReactComponent };